import React from 'react';
import PlacementTestSessionDetailPage from '../placement-tests-session-detail/PlacementTestSessionDetailPage';
import { getAdminKidsTestSessionById } from '../../shared/api/kids-tests.services';

// Разбор ответов выглядит так же, как у взрослого теста, поэтому переиспользуем
// ту же страницу — меняется только запрос за сессией: эндпоинт детского теста
// не отдаёт сессии взрослого.
export default function KidsTestSessionDetailPage() {
  return <PlacementTestSessionDetailPage loadSession={getAdminKidsTestSessionById} />;
}
